module.exports = __webpack_public_path__ + "3dcd0863439ee42374a2ef8a4e5667e7.svg";